import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { meta } from '../../../constants';
import {
  HeaderAvatar,
  HeaderCounters,
  HeaderFollowButton,
  HeaderNames
} from '../components';
import { useHeaderDisplayLogic } from '../helpers';

export function Mobile() {
  const { alias } = meta;
  const isLinkedin = alias === 'linkedin-feed';
  const {
    shouldShowAvatar,
    shouldShowFollowButton,
    hasAnyName,
    hasAnyCounter
  } = useHeaderDisplayLogic();

  const showAvatarOrNames = shouldShowAvatar || hasAnyName;
  const showCountersOrFollowButton = hasAnyCounter || shouldShowFollowButton;

  const getContainerGap = () => {
    if (!isLinkedin) {
      return 8;
    }

    return hasAnyCounter ? 4 : 12;
  };

  return (
    <Container $gap={getContainerGap()}>
      <Show when={showAvatarOrNames}>
        <AvatarAndName>
          <Show when={shouldShowAvatar}>
            <HeaderAvatar />
          </Show>
          <Show when={hasAnyName}>
            <HeaderNames isMobile />
          </Show>
        </AvatarAndName>
      </Show>

      <Show when={showCountersOrFollowButton}>
        <CountersAndButton
          $gap={isLinkedin ? [12, 12] : [12, 24]}
          $direction={isLinkedin ? 'column' : 'row'}
        >
          <Show when={hasAnyCounter}>
            <HeaderCounters isMobile />
          </Show>
          <Show when={shouldShowFollowButton}>
            <HeaderFollowButton isMobile />
          </Show>
        </CountersAndButton>
      </Show>
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'header-mobile',
    element: 'container'
  })
})<{
  $gap: number;
}>`
  display: flex;
  width: 100%;
  gap: ${({ $gap }) => $gap}px;
  flex-direction: column;
  align-items: center;
`;

const AvatarAndName = styled.div.attrs({
  className: createReadableClass({
    component: 'header-mobile',
    element: 'avatar-and-name'
  })
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const CountersAndButton = styled.div.attrs({
  className: createReadableClass({
    component: 'header-mobile',
    element: 'counters-and-button'
  })
})<{
  $gap: [number, number];
  $direction?: CSSProperties['flexDirection'];
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: ${({ $direction }) => $direction};
  gap: ${({ $gap }) => $gap.map((gap) => `${gap}px`).join(' ')};
  width: 100%;
`;
